/**
 * EmptyState — FROZEN PUBLIC CONTRACT
 *
 * @public API (do not change without coordinating agent sign-off):
 *   @Input() icon: string          (Lucide icon name, e.g. 'lucideInbox')
 *   @Input() heading: string
 *   @Input() description: string
 *   <ng-content />                 (optional CTA slot — place a button here)
 *
 * Usage:
 *   <app-empty-state
 *     icon="lucideInbox"
 *     heading="No quotations found"
 *     description="Adjust your filters or create a new quotation."
 *   >
 *     <button hlmBtn variant="outline" size="sm" routerLink="/forwarding/quotes/new">
 *       New Quotation
 *     </button>
 *   </app-empty-state>
 */
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import {
  lucideInbox,
  lucideSearch,
  lucideFileText,
  lucidePackage,
  lucideUsers,
} from '@ng-icons/lucide';

@Component({
  selector: 'app-empty-state',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideIcons({ lucideInbox, lucideSearch, lucideFileText, lucidePackage, lucideUsers })],
  imports: [NgIcon],
  template: `
    <div class="flex flex-col items-center justify-center py-16 text-center">
      <ng-icon
        [name]="icon()"
        class="size-12 mb-4"
        style="color: rgb(var(--ds-mfg, 120 113 108))"
      />
      <h3 class="text-base font-semibold mb-1" style="color: rgb(var(--ds-fg, 28 25 23))">
        {{ heading() }}
      </h3>
      <p class="text-sm mb-4" style="color: rgb(var(--ds-mfg, 120 113 108))">
        {{ description() }}
      </p>
      <ng-content />
    </div>
  `,
})
export class EmptyStateComponent {
  readonly icon = input<string>('lucideInbox');
  readonly heading = input.required<string>();
  readonly description = input<string>('');
}
